<template>
  <div class="main-wrapper">
    <div class="history-header">
      <div class="header-content">
        <p class="header-label">{{ $t('history.balance') }}</p>

        <h1 class="header-balance">
          {{ Number($store.state.amount).toLocaleString() }} ฿
        </h1>

        <div class="header-actions">
          <button
            @click="$router.push('/deposit')"
            class="deposit-btn"
          >
            {{ $t("setting.deposit") }}
          </button>

          <button
            @click="$router.push('/withdraw')"
            class="withdraw-btn"
          >
            {{ $t("setting.withdraw") }}
          </button>
        </div>
      </div>
    </div>

    <div class="history-card">
      <div class="history-card-header p-3">
        <h3>{{ $t("transaction.transactions") }}</h3>

        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab.name"
            @click="selectedTab = tab.name"
            :class="['tab-btn', { active: selectedTab === tab.name }]"
          >
            <span class="whitespace-nowrap">{{ $t(tab.label) }}</span>
          </button>
        </div>
      </div>

      <!-- TAB CONTENT -->
      <div class="history-content">
        <component :is="currentTabComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import UserDepositTable from "@/components/history/UserDepositTable.vue";
import UserTransactions from "@/components/history/UserTransactions.vue";
import UserWithdrawTable from "@/components/history/UserWithdrawTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    UserTransactions,
    UserDepositTable,
    UserWithdrawTable,
  },
  data() {
    return {
      selectedTab: "transactions",
      tabs: [
        {
          name: "transactions",
          label: "transaction.transactions",
          component: "UserTransactions",
        },
        {
          name: "deposits",
          label: "transaction.deposit",
          component: "UserDepositTable",
        },
        {
          name: "withdraws",
          label: "transaction.withdraw",
          component: "UserWithdrawTable",
        },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      const tab = this.tabs.find((t) => t.name === this.selectedTab);
      return tab ? tab.component : null;
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
  },
  async mounted() {
    this.$store.commit("setLoading", true);

    try {
      const authUser = await this.fetchUser();
      if (!authUser) {
        this.$router.push("/auth/login");
        return;
      }
    } finally {
      this.$store.commit("setLoading", false);
    }
  },
};
</script>
<style scoped>
/* ===== HEADER ===== */
.history-header {
  background: linear-gradient(180deg, #2b1c59 0%, #1b1540 100%);
  padding: 26px 16px 40px;
  display: flex;
  justify-content: center;
}

.header-content {
  text-align: center;
  width: 100%;
  max-width: 420px;
}

.header-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 4px;
}

.header-balance {
  font-size: 1.8rem;
  color: white;
  font-weight: 700;
}

/* Buttons (keep your design but refine spacing & typography) */
.header-actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 18px;
}

.deposit-btn {
  background: white;
  color: #390e92 !important;
  font-size: 1rem;
  padding: 0 34px;
  height: 40px;
  border-radius: 40px;
  font-weight: 600;
}

.withdraw-btn {
  background: transparent;
  color: white !important;
  font-size: 1rem;
  padding: 0 34px;
  height: 40px;
  border: 1px solid white;
  border-radius: 40px;
  font-weight: 600;
}

/* ===== MAIN CARD ===== */
.history-card {
  margin-top: -10px;
  background: #2b1c59;
  border-radius: 20px 20px 0 0;
  min-height: 600px;
  overflow: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
}

/* HEADER INSIDE CARD */
.history-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.history-card-header h3 {
  color: white;
  font-size: 1.1rem;
  margin: 0;
}

/* TABS */
.tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  border: 1px solid rgba(255, 255, 255, 0.7);
  color: rgba(255, 255, 255, 0.85);
  padding: 6px 12px;
  border-radius: 30px;
  background: transparent;
  font-size: 0.9rem;
  white-space: nowrap;
}

.tab-btn.active {
  background: white;
  color: #390e92 !important;
  font-weight: 600;
}

/* CONTENT AREA */
.history-content {
  margin-top: 20px;
  padding-bottom: 80px;
}
</style>
